export default [
  {
    path: '/withdraw-audit',
    name: 'withdraw-audit',
    component: resolve => require(['views/withdraw-audit'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/reward-grant-audit/:businessType',
    name: 'award-audit',
    props: true,
    component: resolve => require(['views/award-audit'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/withdraw-audit/withdraw-detail/:id',
    props: true,
    name: 'withdraw-detail',
    component: resolve => require(['views/withdraw-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '提现审核/提现详情' }
  },
  {
    path: '/reward-grant-audit/award-audit-detail/:id/',
    props: true,
    name: 'old-new-audit-detail',
    component: resolve => require(['views/award-audit-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '脐荐康审核/奖励发放详情' }
  },
  {
    path: '/export-history/withdraw-audit',
    props: true,
    name: 'export-withdraw-audit',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '提现审核/提现导出历史' }
  },
  {
    path: '/manual-reward',
    name: 'manual-reward',
    component: resolve => require(['views/manual-reward'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/reward-grant-form',
    name: 'reward-grant-form',
    component: resolve => require(['views/reward-grant-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '手动发放奖励/奖励发放' }
  },
  {
    path: '/reward-grant-audit/award-audit-detail/:id/:isManualReward',
    props: true,
    name: 'manual-audit-detail',
    component: resolve => require(['views/award-audit-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '手动发放奖励/奖励发放详情' }
  },
  {
    path: '/fast-loan-audit',
    name: 'fast-loan-audit',
    component: resolve => require(['views/fast-loan-audit'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/fast-loan-audit/fast-loan-audit-detail/:id',
    name: 'fast-loan-audit-detail',
    props: true,
    component: resolve => require(['views/fast-loan-audit-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '银行分期返惠审核/银行分期返惠详情' }
  },
  {
    path: '/export-history/fast-loan-audit',
    props: true,
    name: 'export-fast-loan-audit',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '银行分期返惠审核/银行分期返惠导出历史' }
  },
  {
    path: '/export-history/old_to_new_audit',
    props: true,
    name: 'export-history-new-audit',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '脐荐康审核/脐荐康奖励记录导出历史' }
  },
  {
    path: '/all-audit',
    name: 'all-audit',
    component: resolve => require(['views/all-audit'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/doctor-invite-reward',
    name: 'medical-reward',
    component: resolve => require(['views/medical-reward'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/export-history/all-audit',
    props: true,
    name: 'export-history-all-audit',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '奖励汇总/奖励导出历史' }
  },
  {
    path: '/export-history/medical-reward',
    props: true,
    name: 'doctor_invite_reward_export',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '河北医护活动/奖励导出历史' }
  },
  {
    path: '/balance-manage',
    name: 'balance-manage',
    component: resolve => require(['views/balance-manage'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/export-history/deposit_settlement',
    props: true,
    name: 'export-history',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '订金结算/订金结算导出历史' }
  },
  {
    path: '/points-reward',
    name: 'points-reward',
    component: resolve => require(['views/points-reward'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/points-grant-form',
    name: 'points-grant-form',
    component: resolve => require(['views/points-grant-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '手动发放积分/积分发放' }
  },
  {
    path: '/export-history/manual-reward',
    props: true,
    name: 'export-history-manual-reward',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '手动发放奖励/奖励导出历史' }
  },
  {
    path: '/export-history/points-reward',
    props: true,
    name: 'export-history-points-reward',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '手动发放积分/积分奖励导出历史' }
  },
  {
    path: '/export-history/doctor-qr-code',
    name: 'doctor-qr-code-history',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '医生管理/医生导出历史' }
  },
  {
    path: '/export-history/pay_order_export',
    name: 'pay_order_export',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '扫码缴费记录/扫码缴费记录导出历史' }
  }
]
